<template>

<DialogBox title="Task Details" :settings="settings" save-on-enter @save="saveTask">
    <div class="pa-3">
        <v-text-field ref="focus" v-model="task.title" label="Task Description" />
        <div class="flex-large">

            <div style="text-align:center;margin-bottom:15px;flex-grow:1">
                <UserChooser v-model="task.assigned" style="margin:auto" :contact="user" :contacts="users" label="Assigned To" @select="userSelected"/>
                <div style="margin-top:10px">{{task.due | dueString}}
                    <span class="grey--text">{{task.stamp | stamp}}</span>
                </div>
                <div class="small-text light-text">{{task.hint}}</div>
            </div>

            <div style="margin-left:25px;">
                <v-date-picker v-model="task.due" no-title @input="pickerClicked"></v-date-picker>
            </div>

        </div>
    </div>
    <template slot="footer">
        <DeleteButton @delete="deleteTask(task)" :disabled="isDisabled" @click.stop.prevent></DeleteButton>

        <v-tooltip right>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" text :color="(task.important ? 'primary' : 'grey lighten-1')" icon @click.stop.prevent="$set(task, 'important', !task.important)">
                <v-icon>mdi-alert-circle</v-icon>
            </v-btn>
            </template>
            <span>Important</span>
        </v-tooltip>
        <v-tooltip v-if="showEmailNotification" right>
            <template v-slot:activator="{ on }">
            <v-btn v-on="on" text :color="(sendEmailNotification ? 'primary' : 'grey lighten-1')" icon @click.stop.prevent="sendEmailNotification = !sendEmailNotification">
                <v-icon>email</v-icon>
            </v-btn>
            </template>
            <span>Send notification to {{notificationRecipient}}</span>
        </v-tooltip>
    </template>
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
import UserChooser from '../ui-elements/UserChooser'

import DialogBox from '../ui-elements/DialogBox'
import NiceData from '../data/NiceData';
import AlertHelpers from '../helpers/AlertHelpers'
import TemplateHelpers from '../helpers/TemplateHelpers'
import EmailHelpers from '../helpers/EmailHelpers';
import ContactHelpers from '../helpers/ContactHelpers'
import DeleteButton from '../ui-elements/DeleteButton'
import ContactData from '../data/ContactData'
import { dateFormats } from '../helpers/DateHelpers'



import {format} from 'date-fns'


export default {
props:{
    task: Object,
    settings: Object,
},
components:{
    DialogBox,
    UserChooser,
    DeleteButton,
},
data() {
    return {
        sendEmailNotification: false,
        showEmailNotification: false,
        users: [],
    }
},
computed: {
    isDisabled() {
        const key = NiceData.safelyGetKey(this.task)
        return !Boolean(key)
    },

    user() {
        return this.$store.getters.user
    },
    tenantKey() {
        if(this.task && this.task.tenantKey)
            return this.task.tenantKey
        if(this.task && this.task.meta && this.task.meta.tenantKey)
            return this.task.meta.tenantKey
        return null
    },
    notificationRecipient() {
        let recipient
        if(this.task && this.task.assigned)
            recipient = this.task.assigned.firstName
        else {
            recipient = ''
        }
        return recipient
    }
},
methods: {

    pickerClicked() {
        this.saveTask()
        this.settings.visible = false
    },

    userSelected(user) {
        let userId = DataHelpers.getUserId()

        this.showEmailNotification = Boolean(user.key != userId)

    },

    initialiseDialog() {
        this.showEmailNotification = false
        this.sendEmailNotification = false
        setTimeout( () => {
            this.$refs.focus.focus()
        }, 300)

        ContactData.fetchUsers().then(users => {
            console.log('fetching users from Task Dialog', users)
            this.users = users
        })
    },

    saveTask() {
        /// ******* TODO: why is uid going missing sometimes
        if(!this.task.assigned.uid) {
            this.task.assigned.uid = DataHelpers.getUserId()
        }

        this.sendEmail()
        this.$emit('save', this.task, this.settings)
    },

    deleteTask(task) {
        const key = NiceData.safelyGetKey(task)
        this.settings.visible = false
        let ref = DataHelpers.getTenantRef().child('tasks').child(key)
        console.log(ref.toString())
        ref.remove()
    },

    sendEmail() {

        if(!this.sendEmailNotification)
            return

        let assignedKey = this.task.assigned.key
        let tenantKey = this.tenantKey

        let ref = DataHelpers.getTenantRef(tenantKey).child('contacts').child(assignedKey)
        NiceData.fetchItemSingle(ref).then(contact => {
            console.log('Contact is ', contact)

            TemplateHelpers.fetchTemplate(tenantKey, 'Notify Broker Task').then(template => {
                console.log('Template is ', template)

                if(!template) {
                    AlertHelpers.showAlert('Template not found: Notify Broker Task')
                    return
                }

                if(!this.task.transactionKey) {
                    AlertHelpers.showAlert('Email not sent, since task was not linked to a transaction');
                }

                let linkToTaco = StringHelpers.linkToTaco( tenantKey + '/transaction/' + this.task.transactionKey, this.task.clients)

                let customFields = {
                    greeting: ContactHelpers.greetingFromContacts([contact]),
                    sender: this.$store.getters.user.firstName,
                    clients: this.task.clients,
                    task_text: this.task.title,
                    task_due: format(new Date(this.task.due), dateFormats.AUSTRALIAN),
                    transaction_link: linkToTaco,
                }


                let body = MergeHelpers.simpleMerge(template.body, customFields)

                let email = {}
                email.to = contact.email
                email.subject = template.subject || ''
                email.body = body
                EmailHelpers.sendEmail(email)

                AlertHelpers.showAlert('Email sent to ' + contact.firstName)
            })

        })
    },



},

created() {

},

watch: {
    'settings.visible' (newVal) {
        if (newVal) {
                this.initialiseDialog()
        }
    }
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// TaskDialog.vue?2383543c